import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import { getCPDataWithoutParams } from 'src/clinic/services'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { GENDER_LIST_OFFLINE } from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'

export default function MentorPatientHistoryPage() {
  const { clinicId, patientId } = useParams()
  const [patientDetails, setPatientDetails] = useState()

  async function getAndSetPatientDetails() {
    const response = await getCPDataWithoutParams(
      `/api/secure/mentor/patient/list?patientId=${patientId}&clinicId=${clinicId}`,
    )
    if (response?.status === 200) {
      setPatientDetails(response?.data?.[0])
    }
  }

  useEffect(() => {
    getAndSetPatientDetails()
  }, [])

  console.log(patientDetails)

  return (
    <>
      <ClinicHeader greetingsEnabled={true} />
      <div className="hide-on-print-only" style={{ padding: '20px' }}>
        <GenericHeaderBackButton
          clickfunction={() => window.history.back()}
          styles={{ cursor: 'pointer' }}
        />
        <div style={{ marginTop: '20px' }}>
          <b>Patient History</b>
        </div>
        <div>Name: {patientDetails?.name}</div>
        <div>Age: {getAgeFromDobWithTime(patientDetails?.dateOfBirth)}</div>
        <div>
          Gender:{' '}
          {GENDER_LIST_OFFLINE?.find((item) => item?.value === patientDetails?.gender)?.label}
        </div>
      </div>
      <LSPastVisitReportsComponent patientId={patientId} />
    </>
  )
}
